export const categories = [
  {
    slug: 'shougong-huangyou-jiaocheng',
    name: '手工黄油制作教程',
    description: '从零开始学习手工黄油制作，掌握每一个关键步骤',
    icon: 'ri-drop-fill',
    color: 'primary',
    articleCount: 6,
  },
  {
    slug: 'fajiao-huangyou-peifang',
    name: '发酵黄油配方',
    description: '探索天然发酵黄油的秘密，解锁深层风味',
    icon: 'ri-flask-fill',
    color: 'accent',
    articleCount: 5,
  },
  {
    slug: 'tiaowei-huangyou-chuangyi',
    name: '调味黄油创意',
    description: '用创意调味让黄油焕发全新生命力',
    icon: 'ri-star-fill',
    color: 'secondary',
    articleCount: 5,
  },
  {
    slug: 'huangyou-hongbei-jiqiao',
    name: '黄油烘焙技巧',
    description: '黄油在烘焙中的百变应用与专业技法',
    icon: 'ri-cake-3-fill',
    color: 'primary',
    articleCount: 4,
  },
  {
    slug: 'kai-dian-zhinan',
    name: '开店指南',
    description: '从手工作坊到品牌化运营的实战经验',
    icon: 'ri-store-3-fill',
    color: 'accent',
    articleCount: 4,
  },
];